<template>
  <v-card
    flat
    class="ma-3 pa-6"
  >
    <v-row align="center" class="pl-0 mb-6 pt-3 pr-3">
      <v-card-title>
        Website Profiles
      </v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        outlined
        dense
        v-model="filter.query"
        placeholder="Search..."
        append-icon="fas fa-search"
        clearable
        clear-icon="fas fa-times"
        single-line
        hide-details
        @keyup="searchKeyUp()"
        @click:clear="searchKeyUp()"
      ></v-text-field>
      <v-btn
        class="ml-4"
        depressed
        color="secondary"
        @click="newClick"
        :disabled="!user.can('website-profile.create')"
      >
    <v-icon
      small
      left
    >fas fa-folder-plus</v-icon>
    New
    </v-btn>
    </v-row>

    <v-data-table
      :class="{ 'clickable': user.can('website-profile.update') }"
      :headers="headers"
      :items="items"
      :options.sync="options"
      :server-items-length="totalCount"
      :footer-props="{ 'items-per-page-options': [5, 10, 50] }"
      :loading="isSearching"
      @click:row="rowClick"
    >
    
    </v-data-table>


    <v-dialog
      v-model="dialog"
      max-width="700"
      persistent
    >
      <v-card>
        <v-toolbar color="primary" dark flat short class="px-2">
          <v-toolbar-title>Website Profile</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false" icon><v-icon>fas fa-times</v-icon></v-btn>
        </v-toolbar>

        <v-card-text class="mt-12">
          <v-form @submit.prevent>

            <v-text-field
              outlined
              class="mb-2"
              v-model="model.name"
              :error-messages="errors.name"
              label="Name"
            ></v-text-field>



          </v-form>
        </v-card-text>

        <v-card-actions class="px-6 pb-8">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="px-5"
            large
            outlined
            depressed
            @click="dialog = false"
          >Cancel</v-btn>
          <v-btn
            color="primary"
            class="px-5"
            large
            depressed
            @click="saveClick()"
          >Save</v-btn>
        </v-card-actions>

      </v-card>

    </v-dialog>

  </v-card>
  
</template>

<script>
import { inject, ref } from 'vue'
import { useRouter } from 'vue-router/composables'

export default {
  components: {
  },
  setup() {
    const api = inject('api')
    const loader = inject('loader')
    const { user } = api
    const router = useRouter()

    const itemCollection = api.collection('website-profiles', {
      params: {
      },
      filter: {
        query: 'query:code,name',
      },
      store: true,
    })

    const { items, filter, totalCount, options, isSearching } = itemCollection



    const headers = [
      { text: 'Name', value: 'name' },
    ]

    const dialog = ref(false)

    const itemModel = api.model('website-profiles/:id', {
      params: {
      },
    })
    const { attributes: model, errors, isBusy } = itemModel

    loader.bindRef(isBusy)

    function newClick() {
      itemModel.clear().setAttributes({ status: 9 })
      dialog.value = true
    }

    function rowClick(item) {
      router.push({
        name: 'website-profile',
        params: { id: item.id }
      })
    }

    function saveClick() {
      itemModel.save().then(() => {
        itemCollection.search()
        dialog.value = false
        router.push({
          name: 'website-profile',
          params: { id: itemModel.getAttribute('id') }
        })
      })
    }

    const searchKeyUp = itemCollection.debounceSearch(300)

    return {
      user,
      headers,
      items,
      filter,
      searchKeyUp,
      totalCount,
      options,
      isSearching,
      newClick,
      rowClick,
      saveClick,
      dialog,
      model,
      errors,
    }

  },
}
</script>


<style scoped>

:deep(.v-data-table.clickable table tbody tr:not(.v-data-table__empty-wrapper):hover) {
  cursor: pointer;
}

</style>
